// Interfaces para la nueva configuración de horarios
export interface ScheduleFrequency {
  type: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'CUSTOM_DAYS' | 'INTERVAL';
  label?: string;
  
  // Para WEEKLY
  weekDays?: number[]; // 0=Domingo, 1=Lunes, etc.
  
  // Para MONTHLY  
  monthDays?: number[]; // 1-31, 'L' para último día
  monthlyType?: 'SPECIFIC_DAYS' | 'LAST_DAY' | 'FIRST_WORKDAY';
  
  // Para INTERVAL
  intervalDays?: number; // cada X días
  startDate?: Date;
  
  // Para CUSTOM_DAYS
  customDays?: number[]; // días específicos del mes
}

export interface ScheduleTime {
  hour: number;
  minute: number;
}

export interface ScheduleConfig {
  frequency: ScheduleFrequency;
  times: ScheduleTime[];  // Array de horarios (sin timezone individual)
  globalTimezone: string; // Zona horaria global para toda la configuración
  
  // Configuración avanzada (opcional)
  advanced?: {
    enabled: boolean;
    cronExpression: string;
  };
  
  // Metadatos
  description: string;
  isActive: boolean;
}

export class Collector {
    id: number;
    sponsor_id: number;
    fronting_id: number | null = null;
    name: string;
    merchant_code: string | null;
    sponsor: any;
    fronting: any;
    status: number;
    days: string[]; // Mantener para compatibilidad
    country_id: number;
    collector_type: string;
    file_generation_path: string;
    
    // Nuevos campos para configuración de horarios
    schedule_config?: {
        type: 'VISUAL' | 'CRON';
        visual_config?: ScheduleConfig;
        cron_expression?: string;
        timezone?: string;
        description?: string;
        is_active?: boolean;
    };
    
    // Schedules desde la API (información completa)
    schedules?: Array<{
        id: number;
        collector_id: number;
        billing_schedule_day?: string;
        schedule_type: 'SIMPLE' | 'CRON';
        cron_expression?: string;
        schedule_hour?: number;
        schedule_minute?: number;
        timezone?: string;
        is_active: boolean;
        description?: string;
        visual_config?: ScheduleConfig;
        status: number;
        creation_date: string;
        modification_date: string;
    }>;
}